import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, take, takeUntil } from 'rxjs';
import { AutoUnsubscribe } from 'src/core/decorators/auto-unsubscribe.decorator';
import { TagDto } from 'src/core/models/conversation/tag/tag.dto';
import { TagService } from '../../services/tag.service';
import { BaseDropdownSelectorComponent } from 'src/ui/base-selector/base-selector.module';
import { TagType } from 'src/core/models/generic-lookup-type/conversation/tag-type.glt';

@Component({
  selector: 'ca-tag-dropdown-selector',
  templateUrl: './tag-dropdown-selector.component.html',
  styleUrls: ['./tag-dropdown-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TagDropdownSelectorComponent),
    },
  ],
  standalone: false,
})
@AutoUnsubscribe()
export class TagDropdownSelectorComponent
  extends BaseDropdownSelectorComponent<TagDto>
  implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor
{
  @Input()
  autoSaveTag: boolean = false;

  constructor(
    protected elementRef: ElementRef,
    protected ngZone: NgZone,
    private service: TagService
  ) {
    super(elementRef, ngZone);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.quickSearchTermInput$
      .pipe(takeUntil(this.autoUnsubscribeNotifier), debounceTime(250), distinctUntilChanged())
      .subscribe(val => {
        this.pageIndex = 0;
        this.quickSearchTerm = val;

        this.load();
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  compareFn(a: TagDto, b: TagDto): boolean {
    return a.id === b.id;
  }

  protected load(): void {
    this.loading = true;

    this.service
      .getList(this.quickSearchTerm, this.pageIndex, this.itemsPerPage)
      .pipe(take(1))
      .subscribe(response => {
        this.totalCount = response.totalCount;
        this.items = response.items;

        this.loading = false;

        if (this.autoSaveTag === false) {
          return;
        }

        if (
          this.quickSearchTerm != null &&
          this.quickSearchTerm.trim().length > 0 &&
          this.items.findIndex(c => c.name.toLowerCase() == this.quickSearchTerm.toLowerCase()) ==
            -1
        ) {
          const newTag = {
            id: 0,
            name: this.quickSearchTerm,
            typeId: TagType.userDefined,
            isStatic: false,
          };
          this.items.unshift(newTag);

          this.value = newTag;

          this.onChange(newTag);
          this.onTouched();
        }
      });
  }
}
